import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "brand-header" }
const _hoisted_2 = { class: "brand-logo" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 0,
  class: "brand-badge"
}
const _hoisted_5 = { class: "brand-content" }
const _hoisted_6 = { class: "brand-name" }
const _hoisted_7 = {
  key: 0,
  class: "brand-desc"
}
const _hoisted_8 = { class: "brand-stats" }
const _hoisted_9 = { class: "stat" }
const _hoisted_10 = { class: "stat-value" }
const _hoisted_11 = { class: "stat-label" }
const _hoisted_12 = { class: "stat" }
const _hoisted_13 = { class: "stat-value" }
const _hoisted_14 = { class: "stat-label" }
const _hoisted_15 = {
  key: 1,
  class: "brand-meta"
}
const _hoisted_16 = { class: "join-date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "brand-card",
    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.handleViewDetails($props.brand)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: $props.brand.logo,
          alt: $props.brand.name,
          onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.handleImageError && $setup.handleImageError(...args)))
        }, null, 40, _hoisted_3)
      ]),
      ($props.brand.featured)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_van_icon, { name: "fire" }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('brands.featured')), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("h3", _hoisted_6, _toDisplayString($props.brand.name), 1),
      ($props.brand.description)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString($props.brand.description), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString($props.brand.productCount || 0) + "+ ", 1),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('brands.products')), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, _toDisplayString($props.brand.verificationCount || 0) + "+ ", 1),
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('brands.verifications')), 1)
        ])
      ]),
      ($props.brand.joinTime)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, [
              _createVNode(_component_van_icon, { name: "clock" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('brands.establishTime')) + " " + _toDisplayString($setup.formatDate($props.brand.establishTime)), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "brand-actions" }, null, -1))
  ]))
}